import { Component, input, output } from "@angular/core";
import { IAllSearch } from "../../../interfaces";
import { NgClass, DatePipe } from "@angular/common";
import { MatIcon } from "@angular/material/icon";
import { MatMiniFabButton } from "@angular/material/button";
import { MatTooltip } from "@angular/material/tooltip";
import { RouterLink } from "@angular/router";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { MatMenuTrigger, MatMenu, MatMenuItem } from "@angular/material/menu";
import { HighlightDirective } from "../../directives/highlight.directive";
import { MatChipSet, MatChip } from "@angular/material/chips";
import DataService from "../../services/data.service";
import DialogService from "../../services/dialog.service";
import ExceptionService from "../../services/exception.service";
import { MatDialog } from "@angular/material/dialog";
import Load from "../../../Dispatch/Shared/models/load.model";

@Component({
    selector: "load-result",
    templateUrl: "./load-result.component.html",
    styleUrl: "./load-result.component.scss",
    imports: [
        NgClass,
        MatIcon,
        MatMiniFabButton,
        MatTooltip,
        RouterLink,
        FaIconComponent,
        MatMenuTrigger,
        HighlightDirective,
        MatChipSet,
        MatChip,
        MatMenu,
        MatMenuItem,
        DatePipe,
    ],
})
export class LoadResultComponent {
    item = input.required<IAllSearch>();
    searchTerm = input.required<string>();
    shortcutClick = output<void>();

    constructor(
        private dialog: MatDialog,
        private dataService: DataService,
        private dialogService: DialogService,
        private exceptionService: ExceptionService
    ) {}

    statusColor(s: string) {
        return `status-${s.replace(" - ", "-").replace(" ", "").toLowerCase()}`;
    }

    parseDate(d: string) {
        return Date.parse(d);
    }

    get fullAddress(): string {
        const parts = [this.item().Address1, this.item().City, this.item().State, this.item().ZIP].filter(Boolean);

        return parts.join(", ");
    }

    get primaryId(): string {
        return `#${this.item().LoadNumber}`;
    }

    get backgroundClass(): string {
        return "";
    }

    get metaLine(): string {
        return `Agent ${this.item().AgentNumber}`;
    }

    loadTrackButton() {
        this.shortcutClick.emit();
    }

    settlementButton() {
        this.shortcutClick.emit();
    }

    orderGridButton() {
        this.shortcutClick.emit();
    }

    async checkinButton() {
        this.shortcutClick.emit();
        this.dispatchStatus(this.item().ID);
    }

    dispatchStatus(loadID: number) {
        this.dataService
            .getApi<Load>(`Load/Edit/${loadID}`)
            .then((result) => {
                let loadModel = new Load(result);
                if (loadModel.DispatchStatusType.ReadOnly) {
                    return this.dialogService.mdAlert("Cannot update loads that are read only status.");
                }
                import("../../../Dispatch/Load/dispatch-status-dialog/dispatch-status-dialog.component").then(
                    ({ DispatchStatusDialogComponent }) => {
                        this.dialog.open(DispatchStatusDialogComponent, {
                            width: "1000px",
                            data: {
                                load: loadModel,
                                loadPOs: this.item().PONumbers?.replace(/,/g, ", "),
                            },
                        });
                    }
                );
            })
            .catch((error) => this.exceptionService.handleException(error));
    }
}
